import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Louistwee
 * id 37D62FB9-6BB0-49D6-8C3E-DF75338DD275
 * name resistor
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/resistor.svg
 * tags
 */
export const ResistorIcon = createSvgIcon(<><path d="M2,11H7L10.07,15.35L13.11,4L18,11H22V13H17L13.93,8.65L10.89,20L6,13H2V11Z" /></>, 'ResistorIcon');
export default ResistorIcon